import angular from 'angular';
import $ from 'jquery';

angular.module('webTools').directive('wtResponsiveImage', ['$timeout', '$window', function ($timeout, $window) {
    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        scope: {
            imageSource: '=',
            leftRightPadding: '=?',
            topBottomPadding: '=?',
            headerCompensate: '=?'
        },
        template: '<div class="image-preview">' +
                    '<img src="{{imageSource}}" class="image-preview-img" />' +
                  '</div>',
        link: function (scope, element, attributes) {

            scope.originalWidth = '';
            scope.originalHeight = '';

            scope.leftRightPadding = scope.leftRightPadding || 0;
            scope.topBottomPadding = scope.topBottomPadding || 0;
            scope.headerCompensate = scope.headerCompensate || 0;

            var resize = function (callback) {
                var img = $(element).find('img');
                var result = {};

                var imageWidth = $(img).width();
                var imageHeight = $(img).height();
                var containerWidth = $(element).parent().width() - scope.leftRightPadding;
                var containerHeight = $(element).parent().height() - scope.topBottomPadding;

                var scaleX1 = containerWidth;
                var scaleY1 = (imageHeight * containerWidth) / imageWidth;

                var scaleX2 = (imageWidth * containerHeight) / imageHeight;
                var scaleY2 = containerHeight;

                var scaleOnWidth = (scaleX2 > containerWidth);

                if (scaleOnWidth) {
                    result.width = Math.floor(scaleX1) > scope.originalWidth ? scope.originalWidth : Math.floor(scaleX1);
                    result.height = Math.floor(scaleY1) > scope.originalHeight ? scope.originalHeight : Math.floor(scaleY1);
                }
                else {
                    result.width = Math.floor(scaleX2) > scope.originalWidth ? scope.originalWidth : Math.floor(scaleX2);
                    result.height = Math.floor(scaleY2) > scope.originalHeight ? scope.originalHeight : Math.floor(scaleY2);
                }

                result.targetleft = Math.floor((containerWidth - result.width) / 2);
                result.targettop = Math.floor((containerHeight - result.height) / 2);

                if (callback) { img.hide(); };

                element.width(result.width);
                element.height(result.height);
                element.css("left", result.targetleft + scope.leftRightPadding / 2);
                element.css("top", result.targettop + (scope.topBottomPadding / 2) - scope.headerCompensate);

                if (callback) { $timeout(function () { callback(); }) }
            }

            element.find('img').on('load', function () {
                scope.originalWidth = element.find('img').width();
                scope.originalHeight = element.find('img').height();

                resize(function () { scope.$emit('imagePreviewLoaded'); element.find('img').fadeIn(); });
            })

            angular.element($window).bind('resize', function () {

                if ($(element).parent().width() < 200 || $(element).parent().height() < 250) { return; }

                resize();
            })
        }
    };
}]);